// filepath: d:\src\com.argodata.cdt.qd2.admin.muiconv\src\components\common\ArgoAppBarHook.js
import * as React from 'react';
import { useState, useContext, useEffect } from 'react';
import PropTypes from "prop-types";
import AppBar from '@mui/material/AppBar';
import { connect } from "react-redux";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import UserContext from "../../UserContext";


const ArgoAppBarHook = (props) => {
    // Replace class state with useState hook
    const [state, setState] = useState({
        url: "",
        childPage: false,
        showMenuIconButton: true,
        showMenuArrowButton: "LEFT",
        prevPage: ""
    });

    // Replace contextType with useContext hook
    const context = useContext(UserContext);
    const { palette } = context;

    // Replace class methods with regular functions
    const onLeftIconButtonTouchTap = () => {
        props.onLeftIconButtonTouchTap();
    };

    const onRightIconButtonTouchTap = () => {
        props.onRightIconButtonTouchTap();
    };

    // const returnToPrevURL = () => {
    //     // if (props.title === "Integration Log Details") {
    //     //     props.closeDrawer();
    //     // }
    //     // else {
    //     setState({
    //         ...state,
    //         childPage: false,
    //         showMenuIconButton: true,
    //         showMenuArrowButton: "LEFT"
    //     });
    //     let path = QD_URL + "/" + state.prevPage;
    //     props.navHook(path, {replace: true});
    //     //}
    // };

    // Replace componentDidUpdate/render logic with useEffect
    useEffect(() => {
        let currURL = window.location.href;

        if ((!props.isDrawer) && (!state.childPage) && (currURL.includes("-versions") || currURL.includes("integration-logs"))) {
            let prevPage;

            if (currURL.includes("integration-logs")) {
                prevPage = "integrations";
            }
            else {
                let urlObj = new URL(currURL);
                let urlPathnameParsedArray = urlObj.pathname.split('/'); // parse pathname part of URL, [2] contains the piece we need

                prevPage = urlPathnameParsedArray[2].replace("-versions", "") + "s"; // Remove "-versions" part of path i.e. group-versions and returns groups for prevPage

                prevPage = (prevPage === "categories") ? "categories" : prevPage;
            }

            setState({
                ...state,
                url: currURL,
                childPage: true,
                showMenuIconButton: false,
                showMenuArrowButton: "LEFT",
                prevPage: prevPage
            });
        } else {
            if (props.isDrawer && state.showMenuArrowButton !== "LEFT") {
                setState({
                    ...state,
                    showMenuArrowButton: "LEFT"
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isDrawer, state.childPage, state.showMenuArrowButton]);

    // Render section from original component
    let hyphenatedTitle = props.title.replaceAll(" ", "-");
    let appBarId = "ArgoAppBar-" + hyphenatedTitle.toLowerCase();

    return (
        <Box>
            <AppBar
                position={props.static ? "static" : "fixed"}
                id={appBarId}
                name={appBarId}
                style={{backgroundColor: palette.accent3Color, width: props.width === undefined ? "100%" : props.width}}
            >
                <Toolbar style={{width: "100%", padding: props.leftNavState ? '0px' : ''}}>
                    {(props.showMenuIconButton && !props.isDrawer) ?
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{mr: 2, marginRight: '0px'}}
                            onClick={onLeftIconButtonTouchTap}
                        >
                            <MenuIcon/>
                        </IconButton>
                        :
                        (!props.noIcon && props.showMenuArrowButton) ?
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="menuArrow"
                                sx={{mr: 2, marginRight: '0px'}}
                                onClick={onLeftIconButtonTouchTap}
                                style={{margin: props.leftNavState ? '0px' : ''}}
                            >
                                {state.showMenuArrowButton === "LEFT" ? <ArrowBackIcon/> : <ArrowForwardIcon/>}
                            </IconButton> : ""
                    }
                    <Typography variant="h5" component="div" sx={{opacity: props.titleFor === "" ? "100%": "85%"}}>
                        {props.title}
                    </Typography>
                    <div>&nbsp;&nbsp;</div>
                    <Typography variant="h5" component="div" sx={{float: "left",
                        maxWidth: props.title === 'Publish:' ? '660px' : props.title === 'Note History:' || props.title === 'Portal Preview:' ? '560px' : props.title === 'Survey Statistics:' ? '440px' : props.title === 'Delete Draft:' ? '510px' : props.title === 'Create Sample Survey:' ? '760px' : '1150px',
                        whiteSpace: 'nowrap',
                        overflow: "hidden",
                        textOverflow: 'ellipsis'}}>
                        {props.titleFor}
                    </Typography>
                    <div>&nbsp;&nbsp;</div>
                    <Typography variant="h7" component="div" sx={{float: "left",
                        maxWidth: props.title === 'References: ' ? '350px' : '250px',
                        whiteSpace: 'nowrap',
                        overflow: "hidden",
                        textOverflow: 'ellipsis'}}>
                        {(props.qualifierFor !== ""
                            && props.qualifierFor !== undefined
                            && props.qualifierFor !== null) ? " -  " + props.qualifierFor : ""}
                    </Typography>
                    {props.showHelpIconButton ?
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{mr: 2}}
                            onClick={onRightIconButtonTouchTap}
                        >
                            <HelpOutlineIcon/>
                        </IconButton>
                        :
                        ""
                    }
                </Toolbar>
            </AppBar>
        </Box>
    );
};

ArgoAppBarHook.defaultProps = {
    title: "QD Administration",
    titleFor: "",
    QualifierFor: "",
    noIcon: false,
    showMenuIconButton: false,
    showMenuArrowButton: "RIGHT",
    showHelpIconButton: false,
    onLeftIconButtonTouchTap: function () {},
    onRightIconButtonTouchTap: function () {},
    isDrawer: false,
    static: false,
    leftNavState: false,
};

ArgoAppBarHook.propTypes = {
    title: PropTypes.string,
    titleFor: PropTypes.string,
    QualifierFor: PropTypes.string,
    noIcon: PropTypes.bool,
    showMenuIconButton: PropTypes.bool,
    showMenuArrowButton: PropTypes.string,
    showHelpIconButton: PropTypes.bool,
    onLeftIconButtonTouchTap: PropTypes.func,
    onRightIconButtonTouchTap: PropTypes.func,
    isDrawer: PropTypes.bool,
    width: PropTypes.string,
    static: PropTypes.bool,
    leftNavState: PropTypes.bool
};

function mapStateToProps(state) {
    return {};
}

// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({closeDrawer},dispatch);
// }

// function myParams(Component,props) {
//     return props => <Component {...props} navHook={useNavigate()} />;
// }

//export default connect(mapStateToProps, mapDispatchToProps)(myParams(ArgoAppBarHook));
export default connect(mapStateToProps)(ArgoAppBarHook);